const fileUrlMixin = {
  methods: {
    getFileUrl (url) {
      // eslint-disable-next-line no-undef
      return !url ? '' : url.startsWith('http') ? url : OSS_HOST + url
    }
  }
}

export default fileUrlMixin
